<div style="height: 100%; overflow: hidden;">


    <cml-panel-buttons [buttons]="buttons"></cml-panel-buttons>

  <div class="collection-table-container" style="height: calc(100% - 46px); overflow: auto;">

    <div *ngIf="(isLoading$ | async)">
    </div>

    <div style="display: flex; flex-direction: column; height: 100%">
      <div style="max-height: calc(100% - 56px); overflow: auto">
    <table #table
           mat-table
           [dataSource]="dataSource"
           matSort
           class="mat-elevation-z0 collection-table">

      <ng-container [matColumnDef]="column.name" *ngFor="let column of visibleColumns, let i = index">
        <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width.px':column.width,'max-width.px':column.width}" [matTooltip]="column.title"
            matTooltipShowDelay="1000"
            disabletooltipinteractivity="true">
          <div style="display: flex;">
            <div *ngIf="filterable !== FilterType.NONE" style="flex-grow: 1;">
              <mat-form-field appearance="fill" [ngStyle]="this.getWidthOfFilter(column)" class="table-field">
                <mat-label>{{column.title}}</mat-label>
                <input matInput autocomplete="off" [formControl]="getFilterGroup(column)" (keyup)="applyFilter($event, column)"/>
              </mat-form-field>
            </div>
            <span *ngIf="filterable === FilterType.NONE">{{column.title}}</span>
            <div *ngIf="filterable === FilterType.FRONTEND" style="display: flex;" mat-sort-header></div>
          </div>
        </th>

        <td mat-cell *matCellDef="let element; let row = dataIndex" [ngStyle]="{'width.px':column.width,'max-width.px':column.width}"
            [matTooltip]="element[column.name]"
        matTooltipShowDelay="1500">
          <span [ngSwitch]="column.type">
            <span *ngSwitchCase="ColumnType.DATETIME">{{getCellValue(element, column.name) | date:'dd.MM.y hh:mm'}}</span>
            <span *ngSwitchCase="ColumnType.BOOLEAN">{{getCellValue(element, column.name) === true ? 'Ano' : (getCellValue(element, column.name) === false ? 'Ne' : '')}}</span>
            <span *ngSwitchCase="ColumnType.ENUM">{{getCellValue(element, column.name) | fromIntToEnum:column.enumType}}</span>
            <span *ngSwitchDefault>{{getCellValue(element, column.name)}}</span>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="visibleFields; sticky:true"></tr>
      <tr mat-row class="mat-table-row"
          [ngClass]="markRow(row) ? 'marked' : '' "
          (click)="selectValue(row)"
          (dblclick)="navigate(row)"
          *matRowDef="let row; columns: visibleFields;"></tr>
    </table>
      </div>
      <div>
        <mat-paginator [length]="resultsLength" [pageSizeOptions]="[10, 15, 20, 25, 300, 3000]" [pageSize]="20"></mat-paginator>
      </div>
    </div>
  </div>
</div>
